import axios from "axios";
import { SERVER_API_URL } from "../constants/constants";

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const searchUploadAccounts = async (search, page, signal) => {
  const { data } = await axios.get(`${SERVER_API_URL}/admin/userallvideo/uploadAccounts`, {
    params: { search, page }, headers: auth(), signal, timeout: 15000,
  });
  return data;
};

export const uploadVideoForAccount = async (userId, formData, onUploadProgress) => {
  const { data } = await axios.post(
    `${SERVER_API_URL}/admin/userallvideo/uploadVideo/${encodeURIComponent(userId)}`,
    formData, { headers: auth(), timeout: 180000, onUploadProgress },
  );
  return data;
};
